import * as React from 'react';
import { Box, Button, MenuItem, Paper, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Modal } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { format } from 'date-fns';
import { useNavigate, useLocation } from "react-router-dom";
import Pool from "./../UserPool";
import { configure } from '../../config';
const config = {
    headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey"
    }
};

export const Dashboard_genesis = () => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [desc, setDesc] = useState("");
    const [customer, setCustomer] = useState("");
    const [species, setSpecies] = useState("");
    const [sampleName, setSampleName] = useState("");
    const [sDate, setSDate] = useState("");
    const [eDate, setEDate] = useState("");
    const [status, setStatus] = useState(0);
    const [filterData, setFilterData] = useState([]);
    const [data, setData] = useState([]);
    var storedValue = sessionStorage.getItem('clickedInstrument')
    console.log(storedValue)
    var user = JSON.parse(sessionStorage.getItem("userProfile"));
    const typeData = JSON.stringify({ type: 'ViewAll', instrument: storedValue, company_name: user.nickname });
    var user = JSON.parse(sessionStorage.getItem("userProfile"));
    const { state } = useLocation();
    const navigate = useNavigate();
    var idToken = JSON.parse(sessionStorage.getItem("idToken"));
    var filterObject = {
        desc: "",
        customer: "",
        species: "",
        sampleName: "",
        sDate: "",
        eDate: "",
        status: 0,
    }
    if (user === null) {
        const userLogin = Pool.getCurrentUser();
        if (userLogin) {
            userLogin.signOut();
        }
        return navigate('/login');
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const experimentData = async () => {
        config.headers.Authorization = idToken.jwtToken;
        const response = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: typeData,
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseData = await response.json();
        if (responseData && response.status === 200) {
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad") {
                sessionStorage.setItem("experimentData", JSON.stringify(responseData.filter(m => m.experiment_status !== "Saved")));
                var filterdata = responseData.filter(m => m.experiment_status !== "Saved")
                setData(filterdata);
                setFilterData(filterdata);
            }
            else {
                sessionStorage.setItem("experimentData", JSON.stringify(responseData));
                setData(responseData);
                setFilterData(responseData);
            }
        }
        else {
            navigate('/login');
        }
    }
    useEffect(() => {
        var response = JSON.parse(sessionStorage.getItem("experimentData"))
        var datafilter = []
        if (state) {
            if (validateFilter(filterObject)) {
                experimentData();
            } else {
                var filterData = JSON.parse(sessionStorage.getItem("filterItem"));
                var originalData = JSON.parse(sessionStorage.getItem("originalData"));
                setData(originalData);
                setFilterData(filterData);
            }
        }
        else {
            experimentData();
        }
    }, []);

    const validateFilter = (filData) => {
        return filData.customer === "" && filData.desc === "" && filData.species === ""
            && filData.sDate === "" && filData.eDate === "" && filData.sampleName === "" &&
            filData.status === 0;
    }

    const dateFilter = (filteredData) => {
        if (sDate !== "" && eDate !== "") {
            // let datas = format(new Date(data[0].experiment_date),  "yyyy-MM-dd");
            if (sDate === eDate) {
                filteredData = data.filter(
                    (obj) => {
                        return new Date(obj.experiment_date) >= new Date(sDate) && new Date(obj.experiment_date) <= new Date(eDate)
                    }
                )
            }
            else {
                filteredData = data.filter(
                    (obj) => {
                        return new Date(obj.experiment_date) >= new Date(sDate) &&
                            new Date(obj.experiment_date) <= new Date(eDate)
                    }
                )
            }

            setFilterData(filteredData)
        }
        else if (sDate !== "") {
            filteredData = data.filter(
                (obj) => {
                    return new Date(obj.experiment_date) >= new Date(sDate)
                }
            )
            setFilterData(filteredData)
        }
        else if (eDate !== "") {
            filteredData = data.filter(
                (obj) => {
                    return new Date(obj.experiment_date) <= new Date(eDate)
                }
            )
            setFilterData(filteredData)
        }
        return filteredData;
    }
    const searchFilter = async (event) => {
        var filteredData = []
        data.forEach(element => {
            element.experiment_date = format(new Date(element.experiment_date), "yyyy-MM-dd")
        });
        setFilterData([]);
        setFilterData(data)
        filteredData = await dateFilter(filteredData);
        if (desc !== "" && species !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(
                    m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                        && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName)
                );
            }
            else {
                filteredData = data.filter(
                    m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                        && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName)
                )
            }
            setFilterData(filteredData)
        }
        else if (species !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase())
                    && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase())
                    && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && species !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                    && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                    && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "" && species !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (species !== "" && sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData);
        }
        else if (species !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (species !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.experiment_status.includes(statusName));
            }
            else {
                filteredData = data.filter(m => m.experiment_status.includes(statusName));
            }
            setFilterData(filteredData);
        }

        if (customer !== "") {

            if (sDate !== "" && eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else if (sDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else if (eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else {
                filteredData = filterData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        sessionStorage.setItem("filterItem", JSON.stringify(filteredData))
        sessionStorage.setItem("originalData", JSON.stringify(data));
    };
    const handleClearFilter = () => {
        setDesc("");
        setSpecies("");
        setSampleName("");
        setCustomer("");
        setSDate("");
        setEDate("");
        setStatus(0);

        setFilterData(data);
        setPage(0);
        setRowsPerPage(10);
        sessionStorage.removeItem("filterAttribute");
        sessionStorage.removeItem("filterItem");
        sessionStorage.removeItem("originalData");
    };
    return (
        <div>
            <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                <Box sx={{ display: 'flex' }}>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextField size="small" placeholder='Description' onKeyDown={searchFilter} value={desc} onChange={(event) => setDesc(event.target.value)} inputProps={{ style: { height: "12px", fontSize: "14px", width: "21.6vw", padding: "10px 14px 8px 14px" } }} />
                    </Box>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextField size="small" placeholder='Species' onKeyDown={searchFilter} value={species} onChange={(event) => setSpecies(event.target.value)} sx={{ width: '82%' }} inputProps={{ style: { height: "12px", fontSize: "14px", padding: "10px 14px 8px 14px" } }} />
                    </Box>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextField size="small" placeholder='Sample Name' onKeyDown={searchFilter} value={sampleName} onChange={(event) => setSampleName(event.target.value)} sx={{ width: '96%' }} style={{ marginLeft: -31 }} inputProps={{ style: { height: "12px", fontSize: "14px", padding: "10px 14px 8px 14px" } }} />
                    </Box>

                </Box>
                <Box sx={{ display: 'flex', marginTop: -1.5 }}>
                    {(user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad" || user.nickname === "BIO-RAD" || user.nickname === "BIORAD") &&
                        <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                            <TextField size="small" placeholder='Company' onKeyDown={searchFilter} value={customer} onChange={(event) => setCustomer(event.target.value)} inputProps={{ style: { height: "12px", fontSize: "14px", width: "21.6vw", padding: "10px 14px 8px 14px" } }} />
                        </Box>
                    }
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextField size="small" type="date" onKeyDown={searchFilter} value={sDate} placeholder='Start Date' onChange={(event) => setSDate(event.target.value)} sx={{ width: '100%' }} style={{ marginRight: 14 }} inputProps={{ style: { height: "13px", fontSize: "14px" } }} />
                        <TextField size="small" type="date" onKeyDown={searchFilter} placeholder='End Date' value={eDate} onChange={(event) => setEDate(event.target.value)} sx={{ width: '100%' }} style={{ marginLeft: 3 }} inputProps={{ style: { height: "13px", fontSize: "14px" } }} />
                    </Box>

                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Select fontWeight={500} placeholder="Status" fontSize={12} size="small" value={status} onChange={(event) => setStatus(event.target.value)} sx={{ width: 153, height: 33, }} >
                            <MenuItem value={0}>--Select Status--</MenuItem>
                            <MenuItem value={2}>Saved</MenuItem>
                            <MenuItem value={3}>Submitted</MenuItem>
                            <MenuItem value={5}>Responded</MenuItem>
                            <MenuItem value={6}>Closed</MenuItem>
                        </Select>
                    </Box>
                    <Box p={1} sx={{ alignContent: "center", marginLeft: 5, marginRight: 0.4 }}>
                        <Button sx={{ width: 20, color: '#fff', bgcolor: '#2962ff' }} onClick={searchFilter} startIcon={<SearchIcon sx={{ marginLeft: 1 }} />} />
                        <Button variant="contained" color="primary" sx={{ width: 20, marginLeft: 1, color: '#fff', bgcolor: '#2962ff' }} onClick={() => handleClearFilter()} >Clear</Button>

                    </Box>

                </Box>
                <Box>


                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', border: 0.5, borderColor: "text.secondary" }} />
            <Box p={1} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer sx={{ height: '56vh' }} >
                        <Table stickyHeader={true} sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="left" ><b>Description</b></TableCell>
                                    <TableCell align="left" sx={{ minWidth: 90 }} ><b>Date</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "left" }}><b>Species</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Workflow Used</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Antibodies Used</b></TableCell>
                                    <TableCell align="left" ><b>Microscope</b></TableCell>
                                    <TableCell align="left" ><b>Magnification</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Microscope Settings</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Template Analysis</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Fluorophore used</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Liquid Biopsy</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "center" }}><b>Sample Name</b></TableCell>
                                    <TableCell align="left" ><b>Status</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ paddingBottom: '10px' }} style={{ textAlign: "center" }}>
                                {(rowsPerPage > 0
                                    ? filterData && filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : filterData
                                ).map(row => (

                                    <TableRow key={row.experiment_id}>
                                        <TableCell align="left">
                                            {
                                                user.nickname !== "Bio-Rad" && (row.experiment_status === "Saved" || row.experiment_status === "Responded") &&
                                                <a href='#' onClick={data => navigate('/genesishome', { state: { data: row, isView: false } })}><p className='text-short'>{row.description}</p></a>
                                            }
                                            {
                                                user.nickname !== "Bio-Rad" && (row.experiment_status === "Submitted" || row.experiment_status === "Acknowledged" || row.experiment_status === "Closed") &&
                                                <a href='#' onClick={data => navigate('/genesishome', { state: { data: row, isView: false } })}><p className='text-short'>{row.description}</p></a>
                                            }

                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Submitted" || row.experiment_status === "Acknowledged") &&
                                                <a href='#' onClick={data => navigate('/genesishome', { state: { data: row, isView: false } })}><p className='text-short'>{row.description}</p></a>
                                            }
                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Responded") &&
                                                <a href='#' onClick={data => navigate('/genesishome', { state: { data: row, isView: false } })}><p className='text-short'>{row.description}</p></a>
                                            }
                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Closed") &&
                                                <a href='#' onClick={data => navigate('/genesishome', { state: { data: row, isView: true } })}><p className='text-short'>{row.description}</p></a>
                                            }

                                        </TableCell>
                                        <TableCell align="left" style={{ textAlign: "left" }}>{format(new Date(row.experiment_date), 'dd-MMM-yy')}</TableCell>
                                        <TableCell align="left" style={{ textAlign: "left" }}>{row.species}</TableCell>
                                        <TableCell align="center">{row.workflow_used}</TableCell>
                                        <TableCell align="center">{row.antibodies_used}</TableCell>
                                        <TableCell align="center">{row.microscope}</TableCell>
                                        <TableCell align="center">{row.magnification}</TableCell>
                                        <TableCell align="center">{row.microscope_settings}</TableCell>
                                        <TableCell align="center">{row.template_analysis}</TableCell>
                                        <TableCell align="center">{row.flourophores_used}</TableCell>
                                        <TableCell align="center">{row.liquid_biopsy}</TableCell>
                                        <TableCell align="left">{row.sample_name}</TableCell>
                                        <TableCell align="left">{row.experiment_status}</TableCell>
                                    </TableRow>
                                ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        colSpan={3}
                        component="div"
                        count={filterData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>

            </Box>
        </div>
    )
}
